import i18nFactory from '@yandex-int/i18n';
import { isFunction, uniq } from 'lodash';

import { bannerModerationAgeFlags, BannerModerationTheme } from '../../typings/domain';
import { ModerationRejectKey } from '../../typings/moderation';

import * as keyset from './Moderation.i18n';

const i18n = i18nFactory(keyset);

const bannerModerationThemeTitles = {
    [BannerModerationTheme.distanceSales]: i18n('distance_sales'),
    [BannerModerationTheme.law]: i18n('law'),
    [BannerModerationTheme.pharmacy]: i18n('pharmacy'),
    [BannerModerationTheme.medServices]: i18n('med-services'),
    [BannerModerationTheme.banks]: i18n('banks'),
    [BannerModerationTheme.alcohol]: i18n('alcohol'),
    [BannerModerationTheme.abortion]: i18n('abortion'),
    [BannerModerationTheme.acids]: i18n('acids'),
    [BannerModerationTheme.adOnTransport]: i18n('transport-adv'),
    [BannerModerationTheme.medEquipment]: i18n('med-equipment'),
    [BannerModerationTheme.optics]: i18n('optics'),
    [BannerModerationTheme.notMedicine]: i18n('not-medicine'),
    [BannerModerationTheme.psychology]: i18n('psychology'),
    [BannerModerationTheme.veterinary]: i18n('veterinary'),
    [BannerModerationTheme.popularMedicine]: i18n('popular-medicine'),
    [BannerModerationTheme.tobacco]: i18n('tobacco'),
    [BannerModerationTheme.dietarySuppl]: i18n('dietarysuppl'),
    [BannerModerationTheme.pseudoWeapon]: i18n('pseudoweapon'),
    [BannerModerationTheme.loan]: i18n('loan'),
    [BannerModerationTheme.insurance]: i18n('insurance'),
    [BannerModerationTheme.maternityCapital]: i18n('maternity-capital'),
    [BannerModerationTheme.pawnshop]: i18n('pawnshop'),
    [BannerModerationTheme.creditConsumerCooperative]: i18n('credit-consumer-cooperative'),
    [BannerModerationTheme.mfi]: i18n('mfi'),
    [BannerModerationTheme.payment]: i18n('payment'),
    [BannerModerationTheme.forex]: i18n('forex'),
    [BannerModerationTheme.forexBroker]: i18n('forex-broker'),
    [BannerModerationTheme.binaryOptions]: i18n('binary-options'),
    [BannerModerationTheme.transport]: i18n('transport'),
    [BannerModerationTheme.detective]: i18n('detective'),
    [BannerModerationTheme.techInspection]: i18n('tech-inspection'),
    [BannerModerationTheme.sportsNutrition]: i18n('sports-nutrition'),
    [BannerModerationTheme.explosions]: i18n('explosions'),
    [BannerModerationTheme.gamble]: i18n('gamble'),
    [BannerModerationTheme.carNumbers]: i18n('car-numbers'),
    [BannerModerationTheme.charity]: i18n('charity'),
    [BannerModerationTheme.lottery]: i18n('lottery'),
    [BannerModerationTheme.illegalDiet]: i18n('illegal-diet'),
    [BannerModerationTheme.drugs]: i18n('drugs'),
    [BannerModerationTheme.telemed]: i18n('telemed'),
    [BannerModerationTheme.electronicOsago]: i18n('electronic-osago'),
    [BannerModerationTheme.bookmaker]: i18n('bookmaker'),
    [BannerModerationTheme.detectiveEquipment]: i18n('detective-equipment'),
    [BannerModerationTheme.jewelry]: i18n('jewelry'),
    [BannerModerationTheme.mediation]: i18n('mediation'),
    [BannerModerationTheme.notary]: i18n('notary'),
    [BannerModerationTheme.realtor]: i18n('realtor'),
    [BannerModerationTheme.weapons]: i18n('weapons'),
    [BannerModerationTheme.magic]: i18n('magic'),
    [BannerModerationTheme.tattoo]: i18n('tattoo'),
    [BannerModerationTheme.workAbroad]: i18n('study'),
    [BannerModerationTheme.foreignTrade]: i18n('foreign-trade'),
    [BannerModerationTheme.cryptoCurrency]: i18n('cryptocurrency')
};

export function getBannerModerationThemeTitle(theme: BannerModerationTheme): string {
    if (!bannerModerationThemeTitles[theme]) {
        throw new Error(`Для запрещенной тематики ${theme} не определено название`);
    }

    return bannerModerationThemeTitles[theme];
}

export function getBannerModerationThemeLink(theme: BannerModerationTheme): string {
    const bannerModerationThemeLinkIds = {
        [BannerModerationTheme.pharmacy]: 'medicine-pharmacies',
        [BannerModerationTheme.banks]: 'finance-banks',
        [BannerModerationTheme.medServices]: 'medicine-medical-activity'

        // код ниже может быть неактуален, при расскомментировании одного из типов тематик ссылку надо проверять
        // [BannerModerationTheme.medEquipment]: 'med-equipment',
        // [BannerModerationTheme.optics]: 'optics',
        // [BannerModerationTheme.notMedicine]: 'not-medicine',
        // [BannerModerationTheme.acids]: 'acids',
        // [BannerModerationTheme.psychology]: 'psychology',
        // [BannerModerationTheme.veterinary]: 'veterinary',
        // [BannerModerationTheme.popularMedicine]: 'popular-medicine',
        // [BannerModerationTheme.alcohol]: 'alcohol',
        // [BannerModerationTheme.tobacco]: 'tobacco',
        // [BannerModerationTheme.dietarySuppl]: 'dietarysuppl',
        // [BannerModerationTheme.pseudoWeapon]: 'pseudoweapon',
        // [BannerModerationTheme.loan]: 'loan',
        // [BannerModerationTheme.insurance]: 'insurance',
        // [BannerModerationTheme.maternityCapital]: 'maternity-capital',
        // [BannerModerationTheme.pawnshop]: 'pawnshop',
        // [BannerModerationTheme.creditConsumerCooperative]:
        //     'credit-consumer-cooperative',
        // [BannerModerationTheme.mfi]: 'mfi',
        // [BannerModerationTheme.payment]: 'payment',
        // [BannerModerationTheme.forex]: 'forex',
        // [BannerModerationTheme.forexBroker]: 'forex',
        // [BannerModerationTheme.binaryOptions]: 'binary-options',
        // [BannerModerationTheme.transport]: 'transport',
        // [BannerModerationTheme.detective]: 'detective',
        // [BannerModerationTheme.techInspection]: 'tech-inspection',
        // [BannerModerationTheme.sportsNutrition]: 'sports-nutrition',
        // [BannerModerationTheme.explosions]: 'explosions',
        // [BannerModerationTheme.gamble]: 'gamble',
        // [BannerModerationTheme.abortion]: 'abortion',
        // [BannerModerationTheme.carNumbers]: 'car-numbers',
        // [BannerModerationTheme.charity]: 'charity',
        // [BannerModerationTheme.lottery]: 'lottery',
        // [BannerModerationTheme.illegalDiet]: 'illegal-diet',
        // [BannerModerationTheme.drugs]: 'drugs',
        // [BannerModerationTheme.telemed]: 'telemed',
        // [BannerModerationTheme.electronicOsago]: 'electronic-osago',
        // [BannerModerationTheme.bookmaker]: 'bookmaker',
        // [BannerModerationTheme.detectiveEquipment]: 'detective-equipment',
        // [BannerModerationTheme.jewelry]: 'jewelry',
        // [BannerModerationTheme.mediation]: 'mediation',
        // [BannerModerationTheme.notary]: 'notary',
        // [BannerModerationTheme.realtor]: 'realtor',
        // [BannerModerationTheme.weapons]: 'weapons',
        // [BannerModerationTheme.magic]: 'magic',
        // [BannerModerationTheme.tattoo]: 'tattoo',
        // [BannerModerationTheme.workAbroad]: 'study',
        // [BannerModerationTheme.foreignTrade]: 'foreign-trade',
        // [BannerModerationTheme.adOnTransport]: 'transport-adv',
        // [BannerModerationTheme.cryptoCurrency]: 'cryptocurrency'
    };
    const id = bannerModerationThemeLinkIds[theme];

    if (!id) {
        throw new Error(`Для запрещенной тематики ${theme} не определена ссылка`);
    }

    return `https://yandex.ru/support/direct/moderation/categories/${id}.html#${id}`;
}

export function getAgeFromBannerModerationTheme(flags: BannerModerationTheme[]): string {
    const ageFlag = flags.find(el => bannerModerationAgeFlags[el] !== undefined);

    if (ageFlag) {
        return bannerModerationAgeFlags[ageFlag];
    }

    return '';
}

const warmingDict = {
    medicine: {
        long_text: i18n('medicine-long-text')
    },
    pharmacy: {
        long_text: i18n('pharmacy-long-text')
    },
    med_equipment: {
        long_text: i18n('med_equipment-long-text')
    },
    dietarysuppl: {
        long_text: i18n('dietarysuppl-long-text')
    },
    alcohol: {
        long_text: i18n('alcohol-long-text')
    },
    abortion: {
        long_text: i18n('abortion-long-text')
    },
    baby_food: {
        long_text: (text: string): string => i18n('baby_food-long-text', { text }),
        default: '11'
    },
    pseudoweapon: {
        long_text: i18n('pseudoweapon-long-text')
    },
    project_declaration: {
        long_text: i18n('project_declaration-long-text')
    },
    med_services: {
        long_text: i18n('med_services-long-text')
    }
};

export function getWarningFromBannerModerationTheme(flags: BannerModerationTheme[]): string {
    return uniq(
        flags
            .filter(el => {
                const [flag] = el.split(':');

                return bannerModerationAgeFlags[el] === undefined && warmingDict[flag];
            })
            .map(el => el.split(':'))
            .map(([flag, value]) => {
                const flagData = warmingDict[flag];

                value = value || flagData.default;

                return isFunction(flagData.long_text) ? flagData.long_text(value) : flagData.long_text;
            })
    ).join(' ');
}

export function getModerationRejectReasonTitle(
    reasonKey: ModerationRejectKey | 'other' | 'external' | 'externalText' | 'outdoor'
): string {
    if (reasonKey === 'other') {
        return i18n('other-reasons');
    }

    const moderationRejectReasonTitles: Record<ModerationRejectKey, string> = {
        [ModerationRejectKey.kazakhLaw]: i18n('kazakh-law'),
        [ModerationRejectKey.copyright]: i18n('copyright'),
        [ModerationRejectKey.spam]: i18n('spam'),
        [ModerationRejectKey.russianLaw]: i18n('russian-law'),
        [ModerationRejectKey.russianLawCallout]: i18n('russian-law-callout'),
        [ModerationRejectKey.yandexPolicy]: i18n('yandex-policy'),
        [ModerationRejectKey.siteRequirements]: i18n('site-requirements'),
        [ModerationRejectKey.newsRequirements]: i18n('news-requirements'),
        [ModerationRejectKey.falseInfo]: i18n('false-info'),
        [ModerationRejectKey.errors]: i18n('errors'),
        [ModerationRejectKey.tm]: i18n('tm'),
        [ModerationRejectKey.invalidUrl]: i18n('invalid-url'),
        [ModerationRejectKey.politics]: i18n('politics'),
        [ModerationRejectKey.contactInfo]: i18n('contact-info'),
        [ModerationRejectKey.licenseRequired]: i18n('license-required'),
        [ModerationRejectKey.irrelevantKeywords]: i18n('irrelevant-keywords'),
        [ModerationRejectKey.russianLawVcard]: i18n('russian-law-vcard'),
        [ModerationRejectKey.licenseRequiredVcard]: i18n('license-required-vcard'),
        [ModerationRejectKey.falseInfoVcard]: i18n('false-info-vcard'),
        [ModerationRejectKey.phoneDoesntAnswer]: i18n('phone-do-not-answer'),
        [ModerationRejectKey.invalidContacts]: i18n('invalid-contacts'),
        [ModerationRejectKey.yandexPolicyAuto]: i18n('yandex-policy-auto'),
        [ModerationRejectKey.yandexPolicyVcard]: i18n('yandex-policy-vcard'),
        [ModerationRejectKey.blacklist]: i18n('blacklist'),
        [ModerationRejectKey.errorsVcard]: i18n('errors-vcard'),
        [ModerationRejectKey.irrelevantImage]: i18n('irrelevant-image'),
        [ModerationRejectKey.yandexPolicyImage]: i18n('yandex-policy-image'),
        [ModerationRejectKey.poorImage]: i18n('poor-image'),
        [ModerationRejectKey.russianLawImage]: i18n('russian-law-image'),
        [ModerationRejectKey.russianLawQl]: i18n('russian-law-ql'),
        [ModerationRejectKey.qlRequirements]: i18n('ql-requirements'),
        [ModerationRejectKey.errorsQl]: i18n('errors-ql'),
        [ModerationRejectKey.invalidUrlQl]: i18n('invalid-url-ql'),
        [ModerationRejectKey.urlToOtherDomain]: i18n('url-to-other-domain'),
        [ModerationRejectKey.licenseRequiredQl]: i18n('license-required-ql'),
        [ModerationRejectKey.irrelevantMobileContent]: i18n('irrelevant-mobile-content'),
        [ModerationRejectKey.irrelevantSiteLinkDescription]: i18n('irrelevant-site-link-description'),
        [ModerationRejectKey.yandexPolicyCallout]: i18n('yandex-policy-callout'),
        [ModerationRejectKey.errorsCallout]: i18n('errors-callout'),
        [ModerationRejectKey.contactInfoCallout]: i18n('contact-info-callout'),
        [ModerationRejectKey.falseInfoCallout]: i18n('false-info-callout'),
        [ModerationRejectKey.dhrefRequirements]: i18n('dhref-requirements'),
        [ModerationRejectKey.licenseRequiredDhref]: i18n('license-required-dhref'),
        [ModerationRejectKey.tmDhref]: i18n('tm-dhref'),
        [ModerationRejectKey.russianLawDhref]: i18n('russian-law-dhref'),
        [ModerationRejectKey.adImageBadText]: i18n('ad-image-bad-text'),
        [ModerationRejectKey.adImageNoBorder]: i18n('ad-image-no-border'),
        [ModerationRejectKey.adImageBadQuality]: i18n('ad-image-bad-quality'),
        [ModerationRejectKey.adImageNoSource]: i18n('ad-image-no-source'),
        [ModerationRejectKey.adImageNasty]: i18n('ad-image-nasty'),
        [ModerationRejectKey.adImageInterfaceElement]: i18n('ad-image-interface-element'),
        [ModerationRejectKey.adImageFinance]: i18n('ad-image-finance'),
        [ModerationRejectKey.adImageLottery]: i18n('ad-image-lottery'),
        [ModerationRejectKey.adImageShareBuilding]: i18n('ad-image-share-building'),
        [ModerationRejectKey.adImageDistance]: i18n('ad-image-distance'),
        [ModerationRejectKey.adImageMedicine]: i18n('ad-image-medicine'),
        [ModerationRejectKey.adImageSmi]: i18n('ad-image-smi'),
        [ModerationRejectKey.adImageBabyfood]: i18n('ad-image-babyfood'),
        [ModerationRejectKey.adImageHouseCooperative]: i18n('ad-image-house-cooperative'),
        [ModerationRejectKey.videoSmi]: i18n('video-smi'),
        [ModerationRejectKey.videoMedicine]: i18n('video-medicine'),
        [ModerationRejectKey.videoHouseCooperative]: i18n('video-house-cooperative'),
        [ModerationRejectKey.videoLottery]: i18n('video-lottery'),
        [ModerationRejectKey.videoShareBuilding]: i18n('video-share-building'),
        [ModerationRejectKey.videoFinance]: i18n('video-finance'),
        [ModerationRejectKey.videoDistanceSales]: i18n('video-distance-sales'),
        [ModerationRejectKey.videoBabyfood]: i18n('video-babyfood'),
        [ModerationRejectKey.videoRequirements]: i18n('video-requirements'),
        [ModerationRejectKey.audioRequirements]: i18n('audio-requirements'),
        [ModerationRejectKey.turbolandingRequirements]: i18n('turbolanding-requirements'),
        [ModerationRejectKey.turbolandingRequirementsSlink]: i18n('turbolanding-requirements-slink'),
        [ModerationRejectKey.html5Nasty]: i18n('html5-nasty'),
        [ModerationRejectKey.html5Babyfood]: i18n('html5-babyfood'),
        [ModerationRejectKey.html5Finance]: i18n('html5-finance'),
        [ModerationRejectKey.html5Funds]: i18n('html5-funds'),
        [ModerationRejectKey.html5BadQuality]: i18n('html5-bad-quality'),
        [ModerationRejectKey.html5RussianLaw]: i18n('html5-russian-law'),
        [ModerationRejectKey.html5Illness]: i18n('html5-illness'),
        [ModerationRejectKey.html5Spam]: i18n('html5-spam'),
        [ModerationRejectKey.html5HouseCooperative]: i18n('html5-house-cooperative'),
        [ModerationRejectKey.html5InterfaceElement]: i18n('html5-interface-element'),
        [ModerationRejectKey.html5NoBorder]: i18n('html5-no-border'),
        [ModerationRejectKey.html5HrefsErrors]: i18n('html5-hrefs-errors'),
        [ModerationRejectKey.html5NoSource]: i18n('html5-no-source'),
        [ModerationRejectKey.html5Smi]: i18n('html5-smi'),
        [ModerationRejectKey.html5Securities]: i18n('html5-securities'),
        [ModerationRejectKey.html5Lottery]: i18n('html5-lottery'),
        [ModerationRejectKey.html5ShareBuilding]: i18n('html5-share-building'),
        [ModerationRejectKey.html5BadText]: i18n('html5-bad-text'),
        [ModerationRejectKey.html5Medicine]: i18n('html5-medicine')
    };

    return moderationRejectReasonTitles[reasonKey];
}
